import { useState, useEffect, useCallback } from 'react';
import { submitFingerprint } from '#speaker-shop/utils/audio-generation-api.client.ts';
import getFingerprint from '#speaker-shop/utils/fingerprint.client.ts';

export function useFingerprint(hasConsent: boolean, isLoggedIn: boolean, anonymousId: string | null) {
    const [ fingerprintId, setFingerprintId ] = useState<string | null>(null);

    const initFingerprintIfNeeded = useCallback(async () => {
        if (hasConsent && !isLoggedIn && !anonymousId && !fingerprintId) {
            try {
                const fp = await getFingerprint();
                if (fp) {
                    setFingerprintId(fp);
                    await submitFingerprint(fp);
                }
            } catch (error) {
                console.error('Failed to initialize fingerprint:', error);
            }
        }
    }, [ hasConsent, isLoggedIn, anonymousId, fingerprintId ]);

    useEffect(() => {
        const onAccept = async () => {
            await initFingerprintIfNeeded();
        };

        const onReject = () => {
        };

        if (hasConsent && !anonymousId && !isLoggedIn) {
            void onAccept();
        }

        window.addEventListener('CookieScriptAccept', onAccept);
        window.addEventListener('CookieScriptReject', onReject);

        return () => {
            window.removeEventListener('CookieScriptAccept', onAccept);
            window.removeEventListener('CookieScriptReject', onReject);
        };
    }, [ hasConsent, isLoggedIn, anonymousId, fingerprintId, initFingerprintIfNeeded ]);

    return { fingerprintId };
}
